// How wide Ask Ogma's side window is (Craig, 31 Oct 2026: "unable to extend the side window to make the table more
// readable"). The person drags its edge or presses Wider; the width is kept for them in this browser and set as
// --chat-side-w, which the side window and the page beside it both read (assistant.css).

const KEY = "ogma.chatSideWidth";
/** Narrower than this and a table stops being readable. */
export const MIN_SIDE = 320;
/** What the chat keeps beside a wide side window, so the conversation is never squeezed out. */
const CHAT_ROOM = 420;
/** One press of an arrow key on the edge. */
export const STEP = 48;

/** A width that fits this screen: at least MIN_SIDE, and leaving the chat its room. */
export function clampSide(width: number, screen: number): number {
  return Math.round(Math.max(MIN_SIDE, Math.min(width, screen - CHAT_ROOM)));
}

/** The widest the side window goes on this screen (Wider). */
export const widestSide = (screen: number) => clampSide(Number.POSITIVE_INFINITY, screen);

/** The width kept for this person, or null for the standard width. Browser storage can be missing or refuse. */
export function savedSide(): number | null {
  try {
    const v = Number(window.localStorage.getItem(KEY));
    return Number.isFinite(v) && v >= MIN_SIDE ? v : null;
  } catch {
    return null;
  }
}

export function applySide(width: number | null, save = true): void {
  const root = document.documentElement.style;
  if (width === null) root.removeProperty("--chat-side-w");
  else root.setProperty("--chat-side-w", `${width}px`);
  if (!save) return;
  try {
    if (width === null) window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, String(width));
  } catch {
    // only a convenience: the width still applies for this visit
  }
}
